import React from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import classNames from 'classnames';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { MediaUploadErrorKey } from 'wix-rich-content-common';
import ErrorIcon from '../Icons/ErrorIcon.js';

var css_248z = ".sKZJ9{align-items:center;color:#fff;display:flex;height:100%;justify-content:center;position:absolute;top:0;width:100%}[dir] .sKZJ9{background:rgba(0,0,0,.5);text-align:center}.eUxPW{height:20px;width:20px}[dir] .d3JYU{margin-bottom:56px}.DsgaX{font-size:16px;line-height:24px;position:absolute}";
var styles = {"error":"sKZJ9","errorIcon":"eUxPW","errorIconWithMessage":"d3JYU","errorMsg":"DsgaX"};
styleInject(css_248z);

const errorMessages = {
  [MediaUploadErrorKey.GENERIC]: "UploadFile_Error_Generic_Item",
  [MediaUploadErrorKey.QUOTA_STORAGE_VISITOR]: "UploadFile_Error_Generic_Item",
  [MediaUploadErrorKey.QUOTA_STORAGE_OWNER]: "UploadFile_Error_Generic_Item",
  [MediaUploadErrorKey.QUOTA_VIDEO_VISITOR]: "UploadFile_Error_Generic_Item",
  [MediaUploadErrorKey.QUOTA_VIDEO_OWNER]: "UploadFile_Error_Generic_Item",
  [MediaUploadErrorKey.SIZE_LIMIT]: "UploadFile_Error_Size_Item"
};
const MediaItemErrorMsg = (props) => {
  const { error, t, isTooltip } = props;
  const errorMsg = error.key && (t == null ? void 0 : t(errorMessages[error.key])) || error.msg || (t == null ? void 0 : t("UploadFile_Error_Generic_Item"));
  const errorIconStyles = classNames(styles.errorIcon, !isTooltip && styles.errorIconWithMessage);
  return /* @__PURE__ */ React.createElement("div", { className: styles.error }, isTooltip ? /* @__PURE__ */ React.createElement(Tooltip, { content: errorMsg, isError: true }, /* @__PURE__ */ React.createElement(ErrorIcon, { className: errorIconStyles })) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ErrorIcon, { className: errorIconStyles }), /* @__PURE__ */ React.createElement("div", { className: styles.errorMsg }, errorMsg)));
};

export { MediaItemErrorMsg as default };
//# sourceMappingURL=MediaItemErrorMsg.js.map
